import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardComponent} from './card.component';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {SharedTranslateModule} from '../../../app/shared/shared-translate.module';
import {FuseSharedModule} from 'fuse-core/shared.module';
import {AssignModalComponent} from './assign-modal/assign-modal.component';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {ButtonListModule} from 'fuse-core/components/button-list/button-list.module';
import { LessonCardBreadcrumbComponent } from './lesson-card-breadcrumb/lesson-card-breadcrumb.component';
import {RouterLink} from "@angular/router";
import {SharedMaterialModule} from 'shared/shared-material.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        MatChipsModule,
        SharedTranslateModule,
        MatSlideToggleModule,
        FuseSharedModule,
        MatDialogModule,
        MatInputModule,
        ButtonListModule,
        RouterLink,
        SharedMaterialModule,
    ],
    declarations: [CardComponent, AssignModalComponent, LessonCardBreadcrumbComponent],
    exports: [
        CardComponent
    ],
})
export class CardModule {
}
